<template>
    <div>
        <form @submit.prevent="on_submit" id="submit_form">
            <div>
                <div class="h5" v-text="$t('wallets.label.transfer')"></div>

                <div class="col-12 col-md-6 my-2">
                    <label for="password" v-text="$t('label.wallet_password')"></label>
                    <input class="form-control" type="password" id="password" name="password" v-model="password.value">
                </div>

                <div v-for="(item, index) in form_data" :key="index">
                    <div class="row border border-success m-2 px-2 pb-4">
                        <div class="col-12">
                            <div class="text-danger ml-auto"
                                 style="cursor: pointer; width: fit-content;"
                                 @click="deleteRow(index)"
                            >
                                <i class="fas fa-trash"></i>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 mb-2">
                            <label :for="`transfers.${index}.amount`" v-text="$t('label.amount_rial')"></label>
                            <amount-input
                                    :item_id="`transfers.${index}.amount`"
                                    :item_name="`transfers.${index}.amount`"
                                    :item="form_data[index]"
                            ></amount-input>
                        </div>

                        <div class="col-12 col-md-6 mb-2">
                            <label :for="`transfers.${index}.destination_wallet_id`" v-text="$t('wallets.label.destination_wallet_id')"></label>
                            <input class="form-control"
                                   :id="`transfers.${index}.destination_wallet_id`"
                                   :name="`transfers.${index}.destination_wallet_id`"
                                   type="text"
                                   v-model="form_data[index].destination_wallet_id"
                            >
                        </div>
                    </div>
                </div>

                <div class="col-12 mt-5 pt-5">
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="d-flex align-items-center justify-content-between">
                            <button class="btn btn-primary mx-2"
                                    type="button"
                                    v-text="$t('label.add_new_record')"
                                    @click="addRow()"
                            >
                            </button>
                            <div class="d-inline-block mx-2">
                                <select id="new_shareholder"
                                        name="new_shareholder"
                                        v-model="new_shareholder"
                                        class="form-control"
                                >
                                    <option :value="null" selected disabled v-text="$t('label.add_new_shareholder')"></option>
                                    <option v-for="(shareholder, index) in shareholders"
                                            :key="index"
                                            :value="shareholder"
                                            v-text="shareholder.first_name + ' ' + shareholder.last_name"
                                    ></option>
                                </select>
                            </div>
                        </div>
                        <div>
                            <button class="btn btn-success ml-auto"
                                    type="submit"
                                    v-text="form_meta_data.submit_btn_text"
                            ></button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import {i18n} from "@/plugins/i18n";
    import AmountInput from "@/components/custom-elements/amount-input";
    import {walletService} from "@/common/api.service";

    export default {
        components: {AmountInput},
        data() {
            return {
                shareholders: [],
                new_shareholder: null,
            };
        },
        props: {
            form_meta_data: {
                type: Object,
                default: () => {
                    return {
                        submit_btn_progress: false,
                        submit_btn_text: i18n.t('btn.submit'),
                    };
                },
            },
            on_submit: {
                type: Function,
                default: () => {
                },
            },
            form_data: Array,
            password: Object,
        },
        watch: {
            new_shareholder(value) {
                if (value === null) {
                    return;
                }

                // if last record is empty, fill it. otherwise add new record
                if (this.form_data[this.form_data.length - 1].destination_wallet_id === '') {
                    this.form_data[this.form_data.length - 1].destination_wallet_id = this.new_shareholder.wallet_hashid;
                } else {
                    this.form_data.push({
                        amount: '',
                        destination_wallet_id: this.new_shareholder.wallet_hashid,
                    });
                }

                this.new_shareholder = null;
            }
        },
        mounted() {
            walletService.shareholderList().then(res => {
                this.shareholders = res.data.data;
            });
        },
        methods: {
            deleteRow(index) {
                if (this.form_data.length < 2) {
                    return;
                }

                this.form_data.splice(index, 1);
            },
            addRow() {
                if (this.form_data.length > 100) {
                    return;
                }

                this.form_data.push({
                    amount: '',
                    destination_wallet_id: '',
                });
            }
        }
    }
</script>
